import { render } from "./PeopleImg.vue?vue&type=template&id=b6a80a04"
import script from "./PeopleImg.vue?vue&type=script&lang=js"
export * from "./PeopleImg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__